(() => {
  function getProductJson() {
    // Viele Themes haben irgendwo ein JSON Script mit Produktdaten
    const candidates = [
      'script[type="application/json"][data-product-json]',
      'script[type="application/json"][id*="ProductJson"]',
      'script[type="application/json"][id*="product-json"]',
      'script[type="application/json"][id*="ProductJSON"]',
      'script[type="application/json"][id*="productJSON"]',
      'script[type="application/json"][id*="productJson"]'
    ];

    for (const sel of candidates) {
      const el = document.querySelector(sel);
      if (!el) continue;
      try {
        const json = JSON.parse(el.textContent);
        if (json && (json.variants || json.product?.variants)) return json.product ?? json;
      } catch (e) {}
    }

    // Fallback: manche Themes setzen global meta
    if (window?.ShopifyAnalytics?.meta?.product?.variants) {
      return window.ShopifyAnalytics.meta.product;
    }

    return null;
  }

  function normalize(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function findSizeOptionIndex(product) {
    const options = product.options || product.options_with_values || [];
    // Options können Strings sein oder Objekte
    const names = options.map(o => normalize(o.name || o));
    // DE/CH Varianten
    const targets = ['grösse', 'groesse', 'größe', 'size'];
    for (let i = 0; i < names.length; i++) {
      if (targets.includes(names[i])) return i; // 0-basiert
    }
    return 0; // fallback: erste Option
  }

  function getAvailableValues(product, optionIndex) {
    const variants = product.variants || [];
    const set = new Set();
    for (const v of variants) {
      if (!v || v.available === false) continue;
      const key = `option${optionIndex + 1}`;
      const val = v[key];
      if (val) set.add(String(val));
    }
    return set;
  }

  function stripEU(value) {
    // "EU 36" -> "36"
    return String(value).replace(/^EU\s*/i, '').trim();
  }

  function applyToPicker(availableSet) {
    // Wir versuchen möglichst “theme-agnostisch” alle Size-Buttons zu finden
    // Typisch: input[type=radio] + label oder button
    const scope = document.querySelector('.product-form') || document;

    // 1) Radio Labels
    const radios = scope.querySelectorAll('input[type="radio"]');
    radios.forEach(input => {
      const label = input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL'
        ? input.nextElementSibling
        : scope.querySelector(`label[for="${CSS.escape(input.id)}"]`);

      if (!label) return;

      const raw = label.textContent || input.value || '';
      const val = stripEU(raw);

      // Wenn es gar nicht nach einer Grösse aussieht, nicht anfassen
      if (!val || val.length > 8) return;

      // Match: entweder Label-Text oder input.value
      const matches =
        availableSet.has(raw.trim()) ||
        availableSet.has(input.value) ||
        availableSet.has(val) ||
        [...availableSet].some(v => stripEU(v) === val);

      if (!matches) {
        // Ganzes Wrapper-Element entfernen, falls vorhanden
        const wrapper = label.closest('li, .variant-input, .variant-picker__value, .pill, .swatch, div, span');
        (wrapper || label).style.display = 'none';
      } else {
        // EU entfernen (nur Anzeige)
        label.textContent = label.textContent.replace(/^EU\s*/i, '');
      }
    });

    // 2) Buttons (falls Theme echte Buttons nutzt)
    const btns = scope.querySelectorAll('button');
    btns.forEach(btn => {
      const raw = (btn.textContent || '').trim();
      if (!raw) return;

      const val = stripEU(raw);
      if (!val || val.length > 8) return;

      const matches =
        availableSet.has(raw) ||
        availableSet.has(val) ||
        [...availableSet].some(v => stripEU(v) === val);

      if (!matches) btn.style.display = 'none';
      else btn.textContent = btn.textContent.replace(/^EU\s*/i, '');
    });
  }

  function run() {
    const product = getProductJson();
    if (!product) return;

    const idx = findSizeOptionIndex(product);
    const available = getAvailableValues(product, idx);
    if (!available || available.size === 0) return;

    applyToPicker(available);
  }

  document.addEventListener('DOMContentLoaded', run);
  // Bei Themes mit dynamischem Re-render:
  new MutationObserver(() => run()).observe(document.documentElement, { subtree: true, childList: true });
})();
